export default __webpack_public_path__ + "static/media/devx-api-marketplace.6336f660.svg";